import React from "react";
import { useTranslation } from "react-i18next";
import { Row, Col, Flex } from "antd";
import { Text } from "../../../../Atomics/Text";
import { Widget } from "../../../../Atomics/Widget";
import { SelectAtomic } from "../../../../Atomics/SelectAtomic";
/* import Spinner from "../../../Atomics/Spinner"; */

export const BuildingLoadDiagram = () => {
  const { t } = useTranslation();

  let dataLoadConsumption = {
    weekday: {
      potencyTop: {
        number: 18.31,
        unit: "kW",
        type: null,
        icon: "Bolt",
      },
      potencyAverage: {
        number: 6.56,
        unit: "kW",
        type: null,
        icon: "Bolt",
      },
    },
    weekend: {
      potencyTop: {
        number: 17.78,
        unit: "kW",
        type: null,
        icon: "Bolt",
      },
      potencyAverage: {
        number: 5.58,
        unit: "kW",
        type: null,
        icon: "Bolt",
      },
    },
    potency: {
      series: [
        {
          name: t("Non-Weekend"),
          type: "line",
          data: [
            {
              x: "00:00",
              y: 8.36,
            },
            {
              x: "01:00",
              y: 18.04,
            },
            {
              x: "02:00",
              y: 18.31,
            },
            {
              x: "03:00",
              y: 17.48,
            },
            {
              x: "04:00",
              y: 16.62,
            },
            {
              x: "05:00",
              y: 15.37,
            },
            {
              x: "06:00",
              y: 13.9,
            },
            {
              x: "07:00",
              y: 12.3,
            },
            {
              x: "08:00",
              y: 8.98,
            },
            {
              x: "09:00",
              y: 4.28,
            },
            {
              x: "10:00",
              y: 3.8,
            },
            {
              x: "11:00",
              y: 2.52,
            },
            {
              x: "12:00",
              y: 1.68,
            },
            {
              x: "13:00",
              y: 1.7,
            },
            {
              x: "14:00",
              y: 1.18,
            },
            {
              x: "15:00",
              y: 1.18,
            },
            {
              x: "16:00",
              y: 1.68,
            },
            {
              x: "17:00",
              y: 1.81,
            },
            {
              x: "18:00",
              y: 1.88,
            },
            {
              x: "19:00",
              y: 1.13,
            },
            {
              x: "20:00",
              y: 1.05,
            },
            {
              x: "21:00",
              y: 1.23,
            },
            {
              x: "22:00",
              y: 1.47,
            },
            {
              x: "23:00",
              y: 1.47,
            },
          ],
        },
        {
          name: t("Weekend"),
          type: "line",
          data: [
            {
              x: "00:00",
              y: 8.5,
            },
            {
              x: "01:00",
              y: 17.78,
            },
            {
              x: "02:00",
              y: 17.48,
            },
            {
              x: "03:00",
              y: 17.05,
            },
            {
              x: "04:00",
              y: 16.26,
            },
            {
              x: "05:00",
              y: 15.17,
            },
            {
              x: "06:00",
              y: 13.54,
            },
            {
              x: "07:00",
              y: 12.06,
            },
            {
              x: "08:00",
              y: 7.7,
            },
            {
              x: "09:00",
              y: 1.14,
            },
            {
              x: "10:00",
              y: 0.21,
            },
            {
              x: "11:00",
              y: 0.14,
            },
            {
              x: "12:00",
              y: 0.11,
            },
            {
              x: "13:00",
              y: 0.16,
            },
            {
              x: "14:00",
              y: 0.09,
            },
            {
              x: "15:00",
              y: 0.12,
            },
            {
              x: "16:00",
              y: 0.13,
            },
            {
              x: "17:00",
              y: 0.18,
            },
            {
              x: "18:00",
              y: 0.35,
            },
            {
              x: "19:00",
              y: 0.61,
            },
            {
              x: "20:00",
              y: 0.88,
            },
            {
              x: "21:00",
              y: 1.32,
            },
            {
              x: "22:00",
              y: 1.46,
            },
            {
              x: "23:00",
              y: 1.54,
            },
          ],
        },
        {
          name: t("Average Total"),
          type: "column",
          data: [
            {
              x: "00:00",
              y: 8.4,
            },
            {
              x: "01:00",
              y: 17.97,
            },
            {
              x: "02:00",
              y: 18.08,
            },
            {
              x: "03:00",
              y: 17.36,
            },
            {
              x: "04:00",
              y: 16.52,
            },
            {
              x: "05:00",
              y: 15.31,
            },
            {
              x: "06:00",
              y: 13.8,
            },
            {
              x: "07:00",
              y: 12.23,
            },
            {
              x: "08:00",
              y: 8.62,
            },
            {
              x: "09:00",
              y: 3.39,
            },
            {
              x: "10:00",
              y: 2.78,
            },
            {
              x: "11:00",
              y: 1.85,
            },
            {
              x: "12:00",
              y: 1.23,
            },
            {
              x: "13:00",
              y: 1.26,
            },
            {
              x: "14:00",
              y: 0.87,
            },
            {
              x: "15:00",
              y: 0.87,
            },
            {
              x: "16:00",
              y: 1.24,
            },
            {
              x: "17:00",
              y: 1.35,
            },
            {
              x: "18:00",
              y: 1.44,
            },
            {
              x: "19:00",
              y: 0.98,
            },
            {
              x: "20:00",
              y: 1.01,
            },
            {
              x: "21:00",
              y: 1.26,
            },
            {
              x: "22:00",
              y: 1.47,
            },
            {
              x: "23:00",
              y: 1.49,
            },
          ],
        },
      ],
      categories: [],
      xAxisType: null,
      labelFormat: null,
      tooltip: null,
      unit: "kW",
      columnWidth: 20,
      xAxisLabel: null,
      yAxisLabel: "kW",
      colors: null,
      filename: "Gráfico exportado",
      headerValue: "valores",
      headerCategory: "hora",
    },
  };

  return (
    <Flex
      id="Load Diagrams"
      className="ant-anchors-content-item"
      gap={32}
      vertical="true"
    >
      <Row>
        <Col span={20}>
          <Text
            $fontColor="coolgray-12"
            $fontSize="text_xl"
            $weight="regular"
            $marginRight="s03"
          >
            {t("Load Diagrams")}
          </Text>
        </Col>
        <Col span={4}>
          {/*  {loadConsumptionLoader
            ? <Flex justify='center'><Spinner stroke="green" size='36px' /></Flex>
            :  */}
          <SelectAtomic
            /* optionsData={selectPotencyType} defaultValue={loadPotencyFilter} handleOptionsChange={handleSelectLoadDiagram} */ fullWidth={
              true
            }
          />
          {/* } */}
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={8}>
          <Flex gap={16} vertical="true">
            <Widget
              data={{
                height: "150px",
                background: "white",
                title: t("Days Of Week"),
                charts: [
                  {
                    cols: 12,
                    title: t("Pick Power"),
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    data: dataLoadConsumption?.weekday?.potencyTop,
                    height: "80px"
                  },
                  {
                    cols: 12,
                    title: t("Average Power"),
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    data: dataLoadConsumption?.weekday?.potencyAverage,
                    height: "80px"
                  },
                ],
              }}
            />
            <Widget
              data={{
                height: "150px",
                background: "white",
                title: t("Saturday And Sunday"),
                charts: [
                  {
                    cols: 12,
                    title: t("Pick Power"),
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    data: dataLoadConsumption?.weekend?.potencyTop,
                    height: "80px"
                  },
                  {
                    cols: 12,
                    title: t("Average Power"),
                    chartType: "bigNumberChart",
                    chartId: "bigNumberChartOne",
                    data: dataLoadConsumption?.weekend?.potencyAverage,
                    height: "80px"
                  },
                ],
              }}
            />
          </Flex>
        </Col>
        <Col span={16}>
          <div /* ref={loadDiagramRef} */>
            <Widget
              data={{
                height: "316px",
                background: "white",
                title: t("Load Diagrams"),
                charts: [
                  {
                    chartType: "mixedLineColumnChartApex",
                    chartId: "mixBarChartLineThree",
                    data: dataLoadConsumption?.potency,
                    height: "250px",
                  },
                ],
              }}
            />
          </div>
        </Col>
      </Row>
    </Flex>
  );
};
